import { useEffect, useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import ClientsTable from 'Components/UI/Organisms/Sales/Clients'
import Create from 'Components/UI/Organisms/Sales/Clients/Create'
import ExportClients from 'Components/UI/Organisms/Sales/Clients/ExportClients'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

import TemplateGlobal from '../../Common'

const ClientTemplate = () => {
  const [dataBefore, setDataBefore] = useState()
  const [render, setRender] = useState(true)
  const { state: openExport, setOpen: setOpenExport, setClose: setCloseExport } = SetState()
  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()
  const BUTTONS = [
    {
      menuIcon: <GetAppIcon fontSize="small" />,
      menuTitle: 'Exportar saldo',
      buttonContent: <GetAppIcon />,
      onClick: setOpenExport,
      disabled: !dataBefore?.data.permissions?.allowExport,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Nuevo',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: dataBefore?.data.permissions.allowCreate
        ? oemColorButton(pathname, location)
        : {},
      disabled: !dataBefore?.data.permissions.allowCreate,
    },
  ]

  async function apiCall() {
    await interfaces.salesClients.clientsBefore().then((res) => {
      setDataBefore({
        data: res.data,
        // permissions: res.data.permissions
      })
    })
  }

  useEffect(() => {
    apiCall()
  }, [render])

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Ventas" subTitle="Clientes" buttons={BUTTONS} />}
        table={<ClientsTable render={render} setRender={setRender} dataBefore={dataBefore} />}
      />

      {openExport.suspense && <ExportClients open={openExport.open} onClose={setCloseExport} />}

      {openNew.suspense && (
        <Create render={render} setRender={setRender} open={setOpenNew} handleClose={setCloseNew} />
      )}
    </div>
  )
}

export default ClientTemplate
